import React, {Component} from "react";

import {SelectValidator, TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import {Button, CircularProgress, Grid, TableCell, TableHead, TableRow} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Select from "@material-ui/core/Select";
import {callback_url, endpoints, http} from '../../configs/http';

import MenuItem from "@material-ui/core/MenuItem";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";

import TextField from "@material-ui/core/TextField";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionCreators} from '../../data/ActionCreators';

import MultiSelect from "react-multi-select-component";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import DateFnsUtils from "@date-io/date-fns";
import {customTheme} from "../History/PaymentHistory";
import axios from 'axios';
import {ToastContainer, toast} from 'react-toastify';
import {thousand} from "../../misc/helpers";
import {Loader} from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

var qs = require('qs');

class Pay extends Component {


    constructor(props) {
        super(props);
        this.state = {
            banks: [],
            name: "",
            description: "",
            disabled: true,
            isCreating: false,
            isDeleting: false,
            bankAccountAccount: "",
            open: false,
            paymentType: "",
            paymentTypes: [],
            members: [],
            narration: "",
            loading: false,
            activeStep: 0,
            chandaFee: '',
            welfareFee: '',
            sportFee: '',
            months: [], years: [],
            taleemFee: '', tablighFee: '', landAndBuildingFee: '',
            vehicleFee: '', atfalSubsidyFee: '', scholarshipFee: '', ijtemaFee: '', paymentMonth: "", paymentYear: "",
            total: 0, naration: '', beneficiary: {},
            selected: [],
            monthsList: [],
            form: {
                atfalSubsidyFee: '',
                chandaFee: '',
                ijtemaFee: '',
                landAndBuildingFee: '',
                paymentMonth: '',
                paymentType: '',
                paymentYear: '',
                scholarshipFee: '',
                sportFee: '',
                tablighFee: '',
                taleemFee: '',

                vehicleFee: '',
                welfareFee: '',
                mgqsFee: '',
                paymentMonthList: [],
            },
            transactionAmount: 0,

            selectedDate: new Date(),
            dateOf: moment(new Date()).format('DD/MM/YYYY'),
            bankAccountId: '',
            receiptURL: '',
            isUploading: false,
            showTransactionDone: false,
            authorizationUrl: null,
            showAddEmail: false,
            email: ''


        }
        this.onChangeFile = this.onChangeFile.bind(this);
    }


    componentDidMount() {
        if (this.props.paymentTemplate.data == null) {
            this.props.getPaymentTemplate();
        }
        console.log(qs.parse(this.props.location.search, {ignoreQueryPrefix: true}).search)
        this.setupMonths()
    }

    setupMonths() {
        const {data} = this.props.paymentTemplate;

        if (data) {
            const newMonths = data.months.map((elem) => ({
                label: elem,
                value: elem,
            }));

            console.log(newMonths)

            this.setState({
                monthsList: newMonths,

            });
        }
    }


    getTemplates() {
        this.setState({
            loading: true
        });
        http.get(endpoints.GET_PAYMENT_TEMPLATE
        )
            .then(response => {
                this.setState({
                    loading: false,
                    banks: response.data.bankAccount,
                    paymentTypes: response.data.paymentTypes,
                    months: response.data.months,
                    years: response.data.years.reverse()
                });

            })
            .catch(error => {
                this.setState({
                    loading: false
                });
                let errorMessage =
                    (typeof error === "string" && error) ||
                    "An error occured, please try again in a moment.";

                // const Toast = Swal.mixin({
                //     toast: true,
                //     position: "top-end",
                //     showConfirmButton: false,
                //     timer: 3000
                // });
                //
                // Toast.fire({
                //     icon: "error",
                //     title: errorMessage
                // });
            });
    }

    getSteps() {
        const {paymentType} = this.state
        if (paymentType === "" || paymentType === "1")
            return ['Payment Details', 'How do you want to make payment', 'Preview']

        else
            return ['Payment Details', 'How do you want to make payment', 'Payment Description', 'Preview']
    }

    onSuccess(reference) {
        // const Toast = Swal.mixin({
        //     toast: true,
        //     position: "top-end",
        //     showConfirmButton: false,
        //     timer: 3000
        // });
        // Toast.fire({
        //     icon: "success",
        //     title: "Payment Request Successful"
        // });
        this.setState({open: false})
    }

    getSumAmount() {
        var form = Object.assign({}, this.state.form);
        let sum = 0;

        [
            'atfalSubsidyFee',
            'chandaFee',
            'ijtemaFee',
            'landAndBuildingFee',
            'mgqsFee',
            'scholarshipFee',
            'sportFee',
            'tablighFee',
            'taleemFee',
            'vehicleFee',
            'welfareFee',
        ].forEach((name) => {
            let value = form[name];

            if (value !== '') {
                sum += parseInt(value);
            }
        });

        return sum;
    }

    isValidField() {
        const {activeStep, selected, form, paymentType, narration, dateOf, bankAccountId, receiptURL} = this.state
        if (activeStep === 0) {
            if (selected.length === 0 || form.paymentYear === '' || this.getSumAmount() === 0) {
                return false
            }
            return true
        } else if (activeStep === 1) {
            if (paymentType !== '') {
                return true
            }
        } else if (activeStep === 2 && this.getSteps().length > 3) {
            if (narration !== '' && dateOf !== '' && bankAccountId !== '' && receiptURL !== '') {
                return true
            }
        }
        return false
    }

    renderPaymentForm() {
        const {data, isLoading} = this.props.paymentTemplate;
        const {
            form,
            monthsList,
            selected,
        } = this.state;
        return (
            <div>
                <ValidatorForm
                    ref={node => (this.form = node)}
                    onSubmit={() => this.handleNext()}
                    onError={this.handleError}
                >
                    <Grid container spacing={3}>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <MultiSelect
                                selectAllLabel={"Select all months"}
                                options={monthsList}
                                value={selected}
                                onChange={this.handleSelectMonth}
                                selectSomeItems={"Select Months"}
                                overrideStrings={{
                                    selectSomeItems: "Select months",
                                    allItemsAreSelected: "All months selected.",
                                    selectAll: "Select All",
                                    search: "Search",
                                    clearSearch: "Clear Search",
                                    clearSelected: "Clear Selected",
                                }}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <SelectValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Select Year"
                                onChange={this.handleOnTextChange.bind(this, 'paymentYear')}
                                type="text"
                                value={form.paymentYear}
                                name="paymentYear"
                                validators={[
                                    "required",
                                ]}
                                errorMessages={["this field is required"]}
                            >
                                {
                                    data.years.reverse().map((year, index) => (
                                        <MenuItem key={index} value={year}>{year}</MenuItem>
                                    ))
                                }

                            </SelectValidator>
                        </Grid>


                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="w-100 mb-8"
                                label="Chanda(Majlis)"
                                onChange={this.handleOnTextChange.bind(this, 'chandaFee')}
                                type="number"
                                name="chandaFee"
                                value={form.chandaFee}
                                validators={[

                                    'matchRegexp:^[1-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Khidmat Kalq(Welfare)"
                                onChange={this.handleOnTextChange.bind(this, 'welfareFee')}
                                type="number"
                                name="welfareFee"
                                value={form.welfareFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Sehat Jismani(Sport)"
                                onChange={this.handleOnTextChange.bind(this, 'sportFee')}

                                type="number"
                                name="sportFee"
                                value={form.sportFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="TaleemTarbiyya"
                                onChange={this.handleOnTextChange.bind(this, 'taleemFee')}
                                type="number"
                                name="taleemFee"
                                value={form.taleemFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Tabligh"
                                onChange={this.handleOnTextChange.bind(this, 'tablighFee')}
                                type="number"
                                name="tablighFee"
                                value={form.tablighFee}
                                validators={[
                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Land & Building"
                                onChange={this.handleOnTextChange.bind(this, 'landAndBuildingFee')}
                                type="number"
                                name="landAndBuildingFee"
                                value={form.landAndBuildingFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>

                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Vehicle"
                                onChange={this.handleOnTextChange.bind(this, 'vehicleFee')}
                                type="number"
                                name="vehicleFee"
                                value={form.vehicleFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Atfal Subsidy"
                                onChange={this.handleOnTextChange.bind(this, 'atfalSubsidyFee')}
                                type="number"
                                name="atfalSubsidyFee"
                                value={form.atfalSubsidyFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Scholarship"

                                onChange={this.handleOnTextChange.bind(this, 'scholarshipFee')}
                                type="number"
                                name="scholarshipFee"
                                value={form.scholarshipFee}
                                validators={[
                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="Ijtema"

                                onChange={this.handleOnTextChange.bind(this, 'ijtemaFee')}
                                type="number"
                                name="ijtemaFee"
                                value={form.ijtemaFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} sm={12} xs={12}>
                            <TextValidator
                                validatorListener={this.handleError}
                                className="mb-8 w-100"
                                label="MGQS"

                                onChange={this.handleOnTextChange.bind(this, 'mgqsFee')}
                                type="number"
                                name="mgqsFee"
                                value={form.mgqsFee}
                                validators={[

                                    'matchRegexp:^[0-9]\\d*$'
                                ]}
                                errorMessages={["Must be postiive integer"]}
                            />
                        </Grid>


                    </Grid>

                </ValidatorForm>

            </div>
        )
    }

    handleDateChange = (date) => {

        this.setState({
            selectedDate: date,
            dateOf: moment(date).format('DD/MM/YYYY'),
        })
    };

    onChangeFile(e) {
        // this.setState({attachment: e.target.files[0]});
        console.log(e.target.files[0])
        this.cloudinaryUpload(e.target.files[0])
    }

    cloudinaryUpload(photo) {
        console.log(photo.uri);
        const data = new FormData();
        data.append('file', photo);
        data.append('upload_preset', 'foijw9mb');
        // foijw9mb
        data.append('cloud_name', 'dfghp0bgq');
        this.setState({
            loading: true,
        });

        axios
            .post('https://api.cloudinary.com/v1_1/dfghp0bgq/image/upload', data, {
                'Content-Type': 'multipart/form-data',
            })
            .then(async (resp) => {
                console.log(resp);
                this.setState({
                    loading: false,
                    receiptURL: resp.data.secure_url,
                });
                toast.success("Image uploaded")
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false,
                });
                let errorMessage =
                    (typeof error === 'string' && error) ||
                    'An error occured, please try again in a moment.';
                // alert(JSON.stringify(error));
                console.log(errorMessage);
                toast.error("Image not uploaded, try again")
            });
    }

    renderPaymentDescription() {
        const {data, isLoading} = this.props.paymentTemplate;
        const {
            form,
            monthsList,
            selected,
            dateOf,
            selectedDate,
            narration,
            bankAccountId
        } = this.state;
        return (

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div>
                    <ValidatorForm
                        ref={node => (this.form = node)}
                        onSubmit={() => this.handleNext()}
                        onError={this.handleError}
                    >
                        <h3>Total Amount to pay: {`₦${thousand(this.getSumAmount())}`}</h3>
                        <Grid container spacing={3}>



                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <KeyboardDatePicker
                                    maxDate={
                                        new Date()
                                    }

                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Date Paid"
                                    format="MM/dd/yyyy"
                                    value={selectedDate}


                                    onChange={this.handleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <TextValidator
                                    validatorListener={this.handleError}
                                    className="mb-8 w-100"
                                    label="Narration"
                                    onChange={this.handleChange}
                                    type="text"
                                    name="narration"
                                    value={narration}

                                    validators={[
                                        "required",
                                    ]}
                                    errorMessages={["Narration is required"]}

                                />
                            </Grid>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <SelectValidator
                                    validatorListener={this.handleError}
                                    className="mb-8 w-100"
                                    label="Bank credited"
                                    onChange={this.handleChange}
                                    type="text"
                                    value={bankAccountId}
                                    name="bankAccountId"
                                    validators={[
                                        "required",
                                    ]}
                                    errorMessages={["this field is required"]}
                                >
                                    {
                                        data.bankAccounts.map((item, index) => (
                                            <MenuItem value={item.id}
                                                      key={index}>{item.name + ' ' + item.accountNumber}</MenuItem>
                                        ))
                                    }

                                </SelectValidator>
                            </Grid>


                            <Grid item lg={6} md={6} sm={12} xs={12}>

                                <div className="form-group">
                                    <label htmlFor="file" className="">Evidence of payment (Receipt, Bank teller
                                        e.t.c)</label>

                                    <div className="">
                                        <input id="file" type="file" className="form-control "
                                               name="file"
                                               accept="image/png, image/jpeg"

                                               onChange={(e) => this.onChangeFile(e)}


                                        />

                                        {this.state.receiptURL !== ''
                                        &&
                                        <img src={this.state.receiptURL} style={{width: 100}}/>
                                        }


                                    </div>
                                </div>
                                {/*<TextValidator*/}
                                {/*    validatorListener={this.handleError}*/}
                                {/*    className="mb-8 w-100"*/}
                                {/*    label="Evidence of payment (Receipt, Bank teller e.t.c)"*/}
                                {/*    onChange={this.onChangeFile}*/}
                                {/*    type="file"*/}
                                {/*    accept="image/png, image/jpeg"*/}

                                {/*    validators={[*/}
                                {/*        "required",*/}
                                {/*    ]}*/}
                                {/*    errorMessages={[ "File is required"]}*/}
                                {/*/>*/}
                            </Grid>


                        </Grid>

                    </ValidatorForm>

                </div>

            </MuiPickersUtilsProvider>

        )
    }

    renderPaymentMethods() {
        const {
            form,
            monthsList,
            selected,
            paymentType
        } = this.state;
        const {data, isLoading} = this.props.paymentTemplate;
        return (
            <div>
                <ValidatorForm
                    ref={node => (this.form = node)}
                    onSubmit={() => this.handleNext()}
                    onError={this.handleError}
                >
                    <Grid container spacing={3}>

                        <Grid item lg={4} md={12} sm={4} xs={4}>

                            <FormControl component="fieldset">
                                <FormLabel component="legend">Payment Option</FormLabel>
                                <RadioGroup aria-label="paymentType" name="paymentType" value={paymentType}
                                            onChange={this.handleChange}>
                                    {

                                        data.paymentTypes.map((payment, index) => (
                                            <FormControlLabel key={index} value={`${payment.id}`}
                                                              control={<Radio/>} label={payment.name}/>
                                        ))
                                    }

                                </RadioGroup>
                            </FormControl>

                        </Grid>
                    </Grid>

                </ValidatorForm>
            </div>
        )
    }

    renderSummary() {
        const {
            showTransactionDone,
            showAddEmail,
            form,
            monthsList,
            selected,
            paymentTypes, chandaFee, welfareFee, sportFee, taleemFee, tablighFee, landAndBuildingFee,
            vehicleFee, atfalSubsidyFee, scholarshipFee, years, months, ijtemaFee, open, banks, bankAccountAccount, beneficiary, paymentType, paymentYear, paymentMonth
        } = this.state;
        const fees = {
            'Chanda': chandaFee,
            'welfare': welfareFee,
            'sport': sportFee,
            'taleem': taleemFee,
            'tabligh': tablighFee,
            'land And Building': landAndBuildingFee,
            'vehicle': vehicleFee,
            'atfalSubsidy': atfalSubsidyFee,
            'scholarship': scholarshipFee,
            'ijtema': ijtemaFee
        }
        const total = Object.values(fees).reduce((a, b) => parseInt(a) + parseInt(b)
        )
        return (
            <div style={{marginTop: 10}}>
                <Card>
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <div>
                                    <b>Payment For:

                                        {
                                            form.paymentMonthList.map((val, index) => (
                                                <span key={index}>{val} </span>
                                            ))
                                        }

                                        , {form.paymentYear}</b>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="table-responsive">
                                    <table id="dataTableExample" className="table">
                                        <thead>
                                        <tr>
                                            <th>Fee</th>
                                            <th>Amount</th>
                                        </tr>
                                        </thead>


                                        <tbody>

                                        <tr>
                                            <td>
                                                Chanda (Majlis)
                                            </td>
                                            <TableCell>
                                                {`₦${thousand(form.chandaFee)}`}
                                            </TableCell>
                                        </tr>
                                        <tr>
                                            <td>
                                                Khidmat Khalq (Welfare)
                                            </td>
                                            <td>
                                                {`₦${thousand(form.welfareFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Seehat Jismani (Sport)
                                            </td>
                                            <td>
                                                {`₦${thousand(form.sportFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Taleem Tarbiyya
                                            </td>
                                            <td>
                                                {`₦${thousand(form.taleemFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Ijtema Fee
                                            </td>
                                            <td>
                                                {`₦${thousand(form.ijtemaFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Tabligh
                                            </td>
                                            <td>
                                                {`₦${thousand(form.tablighFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Landing and Building
                                            </td>
                                            <td>
                                                {`₦${thousand(form.landAndBuildingFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Vehicle
                                            </td>
                                            <td>
                                                {`₦${thousand(form.vehicleFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Atfal Subsidy
                                            </td>
                                            <td>
                                                {`₦${thousand(form.atfalSubsidyFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Scholarship
                                            </td>
                                            <td>
                                                {`₦${thousand(form.scholarshipFee)}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                MGQS
                                            </td>
                                            <td>
                                                {`₦${thousand(form.mgqsFee)}`}
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>
                                                Total
                                            </td>
                                            <td>
                                                {`₦${thousand(this.getSumAmount())}`}
                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </Grid>


                        </Grid>

                        <Dialog
                            open={open}
                            onClose={this.handleClose}
                            aria-labelledby="payment-success"
                            aria-describedby="payment-success-description">
                            <DialogTitle id="payment-success">{"Transaction Summary"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="payment-success">
                                    Jazakallah Khairan. You have now successfully initiated a payment.
                                    Please proceed to pay online
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>

                                {/*<PaystackConsumer {...componentProps} >*/}
                                {/*    {({initializePayment}) => <Button onClick={() => initializePayment()}*/}
                                {/*                                      color="primary" autoFocus>*/}
                                {/*        Pay Online*/}
                                {/*    </Button>}*/}
                                {/*</PaystackConsumer>*/}
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={showTransactionDone}
                            onClose={() => {
                                window.location = '/dashboard'
                            }}
                            aria-labelledby="payment-success"
                            aria-describedby="payment-success-description">
                            <DialogTitle id="payment-success">{"Transaction Complete"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="payment-success">
                                    Jazakallah Khairan. You payment has been received.
                                    Check the payment request table on dashboad page to know when approved
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>

                                <DialogActions>
                                    <Button onClick={() => {
                                        window.location = '/dashboard'
                                    }} color="primary">
                                        Close
                                    </Button>
                                </DialogActions>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={showAddEmail}
                            onClose={() => {
                                this.setState({
                                    showAddEmail: false
                                })
                            }}
                            aria-labelledby="payment-success"
                            aria-describedby="payment-success-description">
                            <DialogTitle id="payment-success">No Email on your profile</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="payment-success">
                                    <div className="form-group">
                                        <label htmlFor="password" className="">Add an email to receive receipt.</label>

                                        <div className="">
                                            <input
                                                className="form-control"
                                                required
                                                onChange={this.handleChange}
                                                type="email"
                                                name="email"
                                                value={this.state.email}
                                            />


                                        </div>
                                    </div>

                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>

                                <DialogActions>
                                    <Button onClick={() => {
                                        if (this.state.email !== "") {
                                            this.handleSubmit()
                                            this.setState({
                                                showAddEmail: false
                                            })
                                        }
                                    }} color="primary">
                                        Proceed
                                    </Button>
                                </DialogActions>
                            </DialogActions>
                        </Dialog>

                    </CardContent>
                </Card>
            </div>
        )
    }

    getStepContent(stepIndex) {
        const {
            form,
            monthsList,
            selected,
            paymentTypes, chandaFee, welfareFee, sportFee, taleemFee, tablighFee, landAndBuildingFee, mgqsFee,
            vehicleFee, atfalSubsidyFee, scholarshipFee, years, months, ijtemaFee, open, banks, bankAccountAccount, beneficiary, paymentType, paymentYear, paymentMonth
        } = this.state;
        const fees = {
            'Chanda': chandaFee,
            'welfare': welfareFee,
            'sport': sportFee,
            'taleem': taleemFee,
            'tabligh': tablighFee,
            'land And Building': landAndBuildingFee,
            'vehicle': vehicleFee,
            'atfalSubsidy': atfalSubsidyFee,
            'scholarship': scholarshipFee,
            'ijtema': ijtemaFee,
            'mgqsFee': mgqsFee
        }
        const total = Object.values(fees).reduce((a, b) => parseInt(a) + parseInt(b)
        )

        const {data, isLoading} = this.props.paymentTemplate;

        // const config = this.getConfig(beneficiary?.email, total * 100)
        //
        //
        // const componentProps = {
        //     ...config,
        //     text: 'Maal Portal',
        //     onSuccess: (reference) => this.onSuccess(reference),
        //     onClose: () => null
        // };
        switch (stepIndex) {
            case 0:
                return (
                    data ?
                        this.renderPaymentForm()
                        :

                        <div>
                            Cannot get payment template, reload page

                        </div>
                )
            case 1:
                return (
                    this.renderPaymentMethods()
                )
            case 2:
                return (
                    this.getSteps().length > 3 ?

                        this.renderPaymentDescription()

                        :

                        this.renderSummary()
                )
            case 3:
                return (
                    this.renderSummary()
                )

        }
    }

    getMembers() {
        this.setState({
            loading: true
        });
        http.get(endpoints.GET_MEMBER
        )
            .then(response => {
                this.setState({
                    error: false,
                    loading: false,
                    members: response.data.content,
                });

            })
            .catch(error => {
                this.setState({
                    loading: false,
                    error: true
                });
                let errorMessage =
                    (typeof error === "string" && error) ||
                    "An error occured, please try again in a moment.";

                // const Toast = Swal.mixin({
                //     toast: true,
                //     position: "top-end",
                //     showConfirmButton: false,
                //     timer: 3000
                // });
                //
                // Toast.fire({
                //     icon: "error",
                //     title: errorMessage
                // });
            });
    }


    handleNext() {
        if (this.state.activeStep === 0) {
            var form = Object.assign({}, this.state.form);
            let sum = 0;

            [
                'atfalSubsidyFee',
                'chandaFee',
                'ijtemaFee',
                'landAndBuildingFee',
                'mgqsFee',
                'scholarshipFee',
                'sportFee',
                'tablighFee',
                'taleemFee',
                'vehicleFee',
                'welfareFee',
            ].forEach((name) => {
                let value = form[name];

                if (value !== '') {
                    sum += parseInt(value);
                    form[name] = value;
                } else {
                    form[name] = '0';
                }
            });

            this.setState({
                form,
                transactionAmount: sum.toString()
            })


        }

        this.setState((state) => {
            return {activeStep: state.activeStep + 1}
        })

    }

    handleBack() {
        this.setState((state) => {
            return {activeStep: state.activeStep - 1}
        })
    }

    handleChange = event => {
        event.persist();
        this.setState({[event.target.name]: event.target.value});

    };

    handleOnTextChange(field, input) {
        const {name, value} = input.target;
        var form = Object.assign({}, this.state.form);
        form[field] = value;
        this.setState({form});
        console.log(form)
    }

    handleSelectMonth = selected => {
        console.log(selected)
        this.setState({selected});
        var months = []
        for (var key in selected) {
            months.push(selected[key].value)
            console.log(selected[key].value)
            // ...
        }

        console.log(months)

        var form = Object.assign({}, this.state.form);
        form['paymentMonthList'] = months;
        form.paymentMonth = months[0];
        this.setState({form});

    };

    handleError = () => {
        let isValid = this.form.isFormValid()
        isValid.then((r) => {
            if (r) this.setState({disabled: false});
        })

    };

    determineSubmition() {
        const {paymentType} = this.state;
        const {auth} = this.props;

        console.log(auth.data.user.email);
        //online payment
        if (paymentType === "1") {
            if (auth.data.user.email !== '') {
                this.handleSubmit();
            } else {
                this.setState({
                    showAddEmail: true,
                });
            }
        } else {
            this.handleSubmit();
        }
    }


    handleSubmit() {
        if (this.state.activeStep !== this.getSteps().length - 1) {
            return
        }

        const {
            form,
            bankAccountId,
            paymentType,
            narration,
            dateOf,
            receiptURL,
            email
        } = this.state


        form.narration = narration

        var req = {
            bankAccountId: bankAccountId,
            paymentType: paymentType,
            transactionAmount: this.getSumAmount(),
            narration: narration,
            details: [form],
            receiptURL: receiptURL,
            dateOf: dateOf,
            callBackUrl: callback_url
        }
        if (email !== '') {
            req.email = email
        }
        this.setState({
            loading: true
        })
        http.post(endpoints.PAYMENT_REQUEST, req
        )
            .then(resp => {
                // this.setState({open: true})
                if (!resp.authorizationUrl) {
                    this.setState({
                        showTransactionDone: true,
                    });
                } else {
                    this.setState({
                        authorizationUrl: resp.authorizationUrl,

                    });
                    window.location = resp.authorizationUrl
                }
                this.setState({
                    loading: false
                })


            })
            .catch(error => {
                this.setState({
                    loading: false
                })
                console.log(error)
                let errorMessage =
                    (typeof error === "string" && error) ||
                    "An error occured, please try again in a moment.";
                toast.error(errorMessage)

                // const Toast = Swal.mixin({
                //     toast: true,
                //     position: "top-end",
                //     showConfirmButton: false,
                //     timer: 3000
                // });
                //
                // Toast.fire({
                //     icon: "error",
                //     title: errorMessage
                // });
            });


    }

    render() {
        const {steps, activeStep, disabled, loading} = this.state;
        return (
            <MuiThemeProvider theme={customTheme}>
                <div className="m-sm-30">
                    <Loader fullPage loading={loading}/>
                    <h2>Make Payment</h2>
                    {/*{this.getSteps().length}*/}
                    {/*{activeStep}*/}
                    <div>

                        <Stepper style={{marginBottom: 30}} activeStep={activeStep} alternativeLabel>
                            {this.getSteps().map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <div>{this.getStepContent(activeStep)}</div>
                        <div style={{marginTop: 30}}>
                            {
                                activeStep === 0 ? '' : <Button
                                    disabled={activeStep === 0}
                                    onClick={() => this.handleBack()}>Back</Button>
                            }

                            {
                                activeStep === this.getSteps().length - 1 ?
                                    <Button variant="contained" size="large"
                                            style={{backgroundColor: '#1b5e20', color: '#ffffff'}}
                                            onClick={this.determineSubmition.bind(this)}>
                                        Submit
                                    </Button> :
                                    !this.isValidField() ?
                                        <Button variant="contained" size="large"
                                                style={{backgroundColor: 'grey', color: '#ffffff'}}
                                                onClick={() => {
                                                }} disabled={disabled}>
                                            Next
                                        </Button>
                                        : <Button variant="contained" size="large"
                                                  style={{backgroundColor: '#1b5e20', color: '#ffffff'}}
                                                  onClick={() => this.handleNext()}>
                                            Next
                                        </Button>
                            }


                        </div>

                        {/*<Button  variant="contained" type="submit" style={{backgroundColor:'#1b5e20', color:'#ffffff'}} disabled={isCreating}>

                                    <span className="pl-8 capitalize">
                                        {isCreating ?
                                            <CircularProgress style={{width: 20, height: 20}}/>
                                            :
                                            "Submit"
                                        }
                                    </span>
                        </Button>*/}
                        <ToastContainer/>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}


// map store state to component props
const mapStateToProps = (state) => {
    // get required state from store state
    var {auth, paymentTemplate} = state;
    // return state
    return {
        auth,
        paymentTemplate,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            getPaymentTemplate: ActionCreators.getPaymentTemplate,
        },
        dispatch,
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Pay);
